var _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgReports = function SvgReports(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    fill: "none",
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 3a6 6 0 0 0-6 6v24a6 6 0 0 0 6 6h13.611L25 47l5.388-8H44a6 6 0 0 0 6-6V9a6 6 0 0 0-6-6H6z",
    clipRule: "evenodd",
    fill: "url(#reports_svg__a)",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m10 24.5 11 6 9.5-14L41 23",
    opacity: 0.4,
    stroke: "#4A3F63",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 11c6.5 15 15 17 32 17",
    stroke: "#3A2D4C",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "reports_svg__a",
    x2: 30.319,
    y1: 3,
    y2: 45.553,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9361D3",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB8DDA",
    offset: 1
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgReports);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9Im5vbmUiIHZlcnNpb249IjEuMSIgdmlld0JveD0iMCAwIDUwIDUwIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxwYXRoIGQ9Im02IDNjLTMuMzEzNyAwLTYgMi42ODYzLTYgNnYyNGMwIDMuMzEzNyAyLjY4NjMgNiA2IDZoMTMuNjExbDUuMzg4NiA4IDUuMzg4Ni04aDEzLjYxMWMzLjMxMzcgMCA2LTIuNjg2MyA2LTZ2LTI0YzAtMy4zMTM3LTIuNjg2My02LTYtNmgtMzh6IiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGZpbGw9InVybCgjcmVwb3J0c2EpIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz48cGF0aCBkPSJtMTAgMjQuNSAxMSA2IDkuNS0xNCAxMC41IDYuNSIgb3BhY2l0eT0iLjQiIHN0cm9rZT0iIzRBM0Y2MyIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBzdHJva2Utd2lkdGg9IjIiLz48cGF0aCBkPSJtOSAxMWM2LjUgMTUgMTUgMTcgMzIgMTciIHN0cm9rZT0iIzNBMkQ0QyIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBzdHJva2Utd2lkdGg9IjIiLz48ZGVmcz48bGluZWFyR3JhZGllbnQgaWQ9InJlcG9ydHNhIiB4Mj0iMzAuMzE5IiB5MT0iMyIgeTI9IjQ1LjU1MyIgZ3JhZGllbnRVbml0cz0idXNlclNwYWNlT25Vc2UiPjxzdG9wIHN0b3AtY29sb3I9IiM5MzYxRDMiIG9mZnNldD0iMCIvPjxzdG9wIHN0b3AtY29sb3I9IiNCQjhEREEiIG9mZnNldD0iMSIvPjwvbGluZWFyR3JhZGllbnQ+PC9kZWZzPjwvc3ZnPgo=";